export default __webpack_public_path__ + "static/media/interrogation.fb8ff339.svg";